import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { ManagementVoyageModel } from '@data-layer/models/management';
import { enumDropdownActionMenuMode } from '@shared/form-wrapper/enums';
import { GenericService } from '@services/generic.service';
import { map } from 'rxjs/operators';
import { enumPublishingState, enumVoyageStatus } from '@data-layer/enums/lcl';

@Component({
  selector: 'voyage-list',
  templateUrl: './voyage-list.component.html',
  styleUrls: ['./voyage-list.component.scss'],
})
export class VoyageListComponent {
  @Input() public header: string = 'LABELS.RECENT_VOYAGES';
  @Input() public canDelete: boolean = false;
  @Input() public canEdit: boolean = false;
  @Input() public canDuplicate: boolean = false;
  @Input() public voyageList$: Observable<ManagementVoyageModel[]>;
  @Input() public isLoading: boolean = false;
  @Input() public total: number;
  @Input() public limit: number;
  @Input() public totalRows: number;
  @Input() public tableId: string | number = 'voyage-list-admin';
  @Input() public page: number = 1;
  @Input() public linkToRoute: boolean = true;
  @Output() public pageChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() public limitChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() public delete: EventEmitter<number> = new EventEmitter<number>();
  @Output() public duplicate: EventEmitter<number> = new EventEmitter<number>();

  public paginationMaxSize$: Observable<number>;
  public menuMode: enumDropdownActionMenuMode = enumDropdownActionMenuMode.LIGHT;
  public enumVoyageStatus: typeof enumVoyageStatus = enumVoyageStatus;
  public enumPublishingState: typeof enumPublishingState = enumPublishingState;

  constructor(private genericService: GenericService) {
    this.paginationMaxSize$ = this.genericService.isMobile$.pipe(map((isMobile) => (isMobile ? 5 : 7)));
  }

  public onPageChange(page: number) {
    this.page = page;
    this.pageChanged.emit(page);
  }
}
